import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setTempAuthed } from '@/redux/slice/login/tempLoginSlice';

export const useAuthForTempToken = (): any => {
  const loginData = useSelector((state: any) => state.login);
  const dispatch = useDispatch();
  useEffect(() => {
    const token = sessionStorage.getItem('temp_token') || '';
    if (token) {
      dispatch(
        setTempAuthed({
          authed: true,
          token,
        })
      );
    }
  }, []);
  const login = (data: any): Promise<boolean> => {
    return new Promise(res => {
      dispatch(
        setTempAuthed({
          authed: true,
          token: data,
        })
      );
      res(true);
    });
  };
  const logout = (): Promise<boolean> => {
    return new Promise(res => {
      dispatch(
        setTempAuthed({
          authed: false,
          token: null,
        })
      );
      sessionStorage.removeItem('temp_token');
      res(true);
    });
  };
  return {
    authed: loginData.authed,
    value: loginData.value,
    login,
    logout,
  };
};
